export enum ConstructorViewMode {
  Card,
  Table,
  Objects,
}
